import {
  eyeIcon,
} from "@excalidraw/excalidraw/components/icons";
import { MainMenu } from "@excalidraw/excalidraw/index";
import React from "react";
import { isDevEnv } from "@excalidraw/common";
import type { Theme } from "@excalidraw/element/types";
import { LanguageList } from "../app-language/LanguageList";
import { saveDebugState } from "./DebugCanvas";

const SisiLogo: React.FC<{ theme: Theme | "system" }> = ({ theme }) => {
  const fill = theme === "dark" ? "#ffffff" : "#000000";
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 564.41 89.1" style={{ height: 20, width: "auto" }}>
      <g fill={fill}>
        <path d="M31.17,41.62l-9.79-2.1c-4.48-1.05-6.68-2.77-6.68-5.29,0-3.29,3.15-5.5,7.97-5.5,5.15,0,8.45,2.54,8.74,6.64h12.83c-.19-9.93-8.54-16.42-21.38-16.42S1.29,25.34,1.29,35.09c0,7.54,4.96,12.59,14.66,14.8l9.44,2.1c4.58,1.1,6.31,2.53,6.31,5.1,0,3.34-3.21,5.44-8.5,5.44s-8.92-2.48-9.54-6.77H0c.76,9.97,9.16,16.56,22.81,16.56s22.76-6.64,22.76-16.69c0-7.66-4.15-11.71-14.4-14Z"/>
        <path d="M60.81,0c-3.95.16-7.02,3.49-6.86,7.44.16,3.95,3.49,7.02,7.44,6.86,3.83-.15,6.87-3.31,6.87-7.14C68.22,3.17,64.95-.04,60.96,0c-.05,0-.1,0-.15,0Z"/>
        <rect x="53.82" y="20.05" width="13.94" height="51.17"/>
        <path d="M106.93,41.62l-9.78-2.1c-4.48-1.05-6.68-2.77-6.68-5.29,0-3.29,3.15-5.5,7.97-5.5,5.15,0,8.44,2.54,8.73,6.64h12.84c-.19-9.93-8.54-16.42-21.38-16.42s-21.57,6.39-21.57,16.13c0,7.54,4.96,12.59,14.66,14.8l9.44,2.1c4.58,1.1,6.3,2.53,6.3,5.1,0,3.34-3.2,5.44-8.49,5.44s-8.92-2.48-9.54-6.77h-13.65c.76,9.97,9.16,16.56,22.81,16.56s22.76-6.64,22.76-16.69c0-7.66-4.15-11.71-14.42-14Z"/>
        <rect x="129.57" y="20.05" width="13.94" height="51.17"/>
        <path d="M136.55,0c-3.99-.13-7.32,3.01-7.45,7,0,.05,0,.11,0,.16-.16,4.11,3.04,7.58,7.15,7.74,4.11.16,7.58-3.04,7.74-7.15.16-4.11-3.04-7.58-7.15-7.74-.1,0-.19,0-.29,0Z"/>
        <path d="M173.69,20.81c-10.84,0-17.99,5.96-18.95,15.18h3.58c1.19-7.5,6.68-11.84,15.32-11.84s13.98,5.21,13.98,13.8v4.44l-17.08,1.19c-11.46.91-17.56,5.77-17.56,14.31s6.73,14.13,16.42,14.13c8.35,0,15.74-4.69,18.27-11.41h.1v10.65h3.58v-33.59c.01-10.36-6.77-16.85-17.65-16.85ZM187.62,52.79c0,8.82-7.92,15.93-17.7,15.93-7.69,0-13.22-4.53-13.22-10.88s5.06-10.51,14.37-11.22l16.55-1.19v7.36Z"/>
        <path d="M239.27,34.58h-.1c-2.39-8.24-9.98-13.88-18.57-13.77-12.41,0-21.09,10.31-21.09,25.58s8.73,25.59,21.09,25.59c8.7.06,16.36-5.71,18.71-14.08h.14v13.32h3.48V2.39h-3.72l.05,32.2ZM221.13,68.63c-10.55,0-17.89-8.97-17.89-22.29s7.35-22.19,17.89-22.19,18.18,9.07,18.18,22.24-7.55,22.24-18.18,22.24Z"/>
        <polygon points="270.23 67.48 270.09 67.48 253.2 21.58 249.23 21.58 267.94 71.22 272.38 71.22 291.04 21.58 287.13 21.58 270.23 67.48"/>
        <path d="M315.76,20.81c-13.12,0-21.76,10.22-21.76,25.63s8.65,25.54,22.14,25.54c11.08,0,18.61-6.26,20.27-14.66h-3.72c-1.48,6.49-7.39,11.35-16.5,11.35-11.13,0-18.42-7.97-18.42-21.46v-.19h39.28v-2.11c.01-14.4-8.44-24.1-21.29-24.1ZM297.81,43.91c.54-11.83,7.6-19.81,17.89-19.81s17.48,8.1,17.53,19.81h-35.42Z"/>
        <path d="M349.08,31.37h-.1v-9.79h-3.48v49.64h3.72v-30.93c0-9.3,4.77-15.94,12.65-15.94,1.77-.05,3.53.29,5.15,1v-3.72c-1.48-.55-3.05-.82-4.63-.81-6.59,0-11.27,3.72-13.32,10.55Z"/>
        <path d="M381.33,59.81V24.77h9.98v-3.2h-9.98v-13.02h-3.67v13.02h-7.39v3.2h7.39v35.13c0,8.2,3.1,11.41,10.36,11.41.57,0,3.58,0,3.96-.1v-3.24h-3.43c-5.02,0-7.21-2.3-7.21-8.17Z"/>
        <path d="M402.71,3.58c-1.59-.01-2.9,1.27-2.91,2.86h0c.1,1.61,1.49,2.83,3.1,2.73,1.47-.09,2.64-1.26,2.73-2.73-.01-1.59-1.32-2.88-2.91-2.86,0,0,0,0-.01,0Z"/>
        <rect x="400.85" y="21.58" width="3.72" height="49.64"/>
        <path d="M436.65,45.2l-6.87-1.62c-7.98-1.86-11.32-4.63-11.32-9.44,0-5.88,5.58-10.12,13.27-10.12s13.26,4.44,14.31,11.79h3.58c-.91-9.22-7.79-14.99-17.8-14.99s-16.94,5.63-16.94,13.46c0,6.34,4.25,10.3,13.55,12.5l7.15,1.67c7.97,1.92,11.11,4.69,11.11,9.93,0,6.11-5.96,10.4-14.4,10.4s-14.49-4.67-15.39-11.53h-3.67c.76,8.63,8.54,14.75,18.95,14.75s18.23-5.74,18.23-13.84c0-6.98-3.88-10.61-13.75-12.95Z"/>
        <path d="M460.89,3.58c-1.59-.01-2.9,1.27-2.91,2.86h0c0,1.61,1.3,2.91,2.91,2.91s2.91-1.3,2.91-2.91c-.01-1.59-1.32-2.88-2.91-2.86,0,0,0,0,0,0Z"/>
        <rect x="459.03" y="21.58" width="3.72" height="49.64"/>
        <path d="M494.93,20.81c-8.45,0-14.94,4.77-17.18,11.55h-.1v-10.73h-3.48v49.58h3.72v-29.64c0-10.3,6.58-17.42,16.18-17.42s15.26,5.78,15.26,15.37v31.7h3.72v-32.2c0-11.15-7.2-18.21-18.13-18.21Z"/>
        <path d="M560.93,21.58v13.32h-.1c-2.33-8.33-9.92-14.09-18.57-14.08-12.51,0-21,10.27-21,25.53s8.44,25.49,20.95,25.49c8.53.06,16.05-5.59,18.38-13.8h.14v12.75c0,9.06-6.55,15.07-16.85,15.07-8.55,0-14.31-4.1-15.99-9.4h-3.82c1.38,7.01,8.87,12.64,19.62,12.64,12.7,0,20.71-7.35,20.71-18.46V21.58h-3.48ZM542.7,68.49c-10.55,0-17.71-8.87-17.71-22.1s7.15-22.24,17.71-22.24,18.04,9.07,18.04,22.19-7.44,22.14-18.04,22.14Z"/>
      </g>
    </svg>
  );
};

export const AppMainMenu: React.FC<{
  onCollabDialogOpen: () => any;
  isCollaborating: boolean;
  isCollabEnabled: boolean;
  theme: Theme | "system";
  setTheme: (theme: Theme | "system") => void;
  refresh: () => void;
}> = React.memo((props) => {
  return (
    <MainMenu>
      <MainMenu.ItemCustom>
        <div style={{ padding: "8px 12px 4px" }}>
          <SisiLogo theme={props.theme} />
        </div>
      </MainMenu.ItemCustom>
      <MainMenu.Separator />
      <MainMenu.DefaultItems.SaveAsImage />
      {props.isCollabEnabled && (
        <MainMenu.DefaultItems.LiveCollaborationTrigger
          isCollaborating={props.isCollaborating}
          onSelect={() => props.onCollabDialogOpen()}
        />
      )}
      <MainMenu.DefaultItems.CommandPalette className="highlighted" />
      <MainMenu.DefaultItems.SearchMenu />
      <MainMenu.DefaultItems.Help />
      <MainMenu.DefaultItems.ClearCanvas />
      {isDevEnv() && (
        <>
          <MainMenu.Separator />
          <MainMenu.Item
            icon={eyeIcon}
            onSelect={() => {
              if (window.visualDebug) {
                delete window.visualDebug;
                saveDebugState({ enabled: false });
              } else {
                window.visualDebug = { data: [] };
                saveDebugState({ enabled: true });
              }
              props?.refresh();
            }}
          >
            Visual Debug
          </MainMenu.Item>
        </>
      )}
      <MainMenu.Separator />
      <MainMenu.DefaultItems.Preferences />
      <MainMenu.DefaultItems.ToggleTheme
        allowSystemTheme
        theme={props.theme}
        onSelect={props.setTheme}
      />
      <MainMenu.ItemCustom>
        <LanguageList style={{ width: "100%" }} />
      </MainMenu.ItemCustom>
      <MainMenu.DefaultItems.ChangeCanvasBackground />
    </MainMenu>
  );
});
